import { useEffect, useState } from "react";
import {
  Card,
  Autocomplete,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import moment from "moment";
import BTBox from "../../components/BTBox";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
import { useDispatch, useSelector } from "react-redux";
import { get_parties, get_sizes } from "../../store/functions";
import EnhancedTable from "../../components/BTTable";
import { fetchData } from "../../utils/fetchData";
import { get } from "../../store/labSlice";
import { useLoading } from "../../context";
const default_search = {
  type: 2,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 1000000,
  page: 1,
  searchText: null,
  last_id: 0,
  status: null,
  p_stn_id: null,
};
const CardHeader = ({
  search,
  filter,
  loading,
  setSearch,
  clearState,
  parties,
  setFilter,
  onGenerateReport,
  onDownloadReport,
  setReports,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || null,
    to_date: search?.to_date || null,
  });

  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setReports(null);
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}
      >
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
          <Autocomplete
            options={parties || []}
            getOptionLabel={(option) =>
              `${option.p_code} : ${option.p_name}` || ""
            }
            renderOption={(props, option) => (
              <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
            )}
            onChange={(event, value) => {
              clearState();
              setReports(null);
              setSearch({ ...search, p_id: value?.p_id, page: 1 });
            }}
            sx={{ width: "100%" }}
            value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Party"
                size="small"
                variant="standard"
                sx={{ width: { xs: "100%", sm: "200px" } }}
              />
            )}
          />
        </BTBox>
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                color="info"
                checked={filter?.partywise}
                onChange={(e) => {
                  setReports(null);
                  setFilter((prev) => ({
                    ...prev,
                    partywise: e.target.checked,
                  }));
                }}
              />
            }
            label="Party"
          />
          <FormControlLabel
            control={
              <Checkbox
                color="info"
                checked={filter?.sizewise}
                onChange={(e) => {
                  setReports(null);
                  setFilter((prev) => ({
                    ...prev,
                    sizewise: e.target.checked,
                  }));
                }}
              />
            }
            label="Size"
          />
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            sx={{ width: { xs: "100%", sm: "150px" } }}
            onClick={onGenerateReport}
          >
            {loading ? <CircularProgress size={20} /> : "generate report"}
          </BTButton>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            sx={{ width: { xs: "100%", sm: "160px" } }}
            onClick={onDownloadReport}
          >
            download report
          </BTButton>
        </BTBox>
      </BTBox>
    </Card>
  );
};

const Report = () => {
  const { showLoading, hideLoading } = useLoading();
  const dispatch = useDispatch();
  const submission = useSelector((state) => state?.lab?.submission);
  const parties = useSelector((state) => state?.lab?.parties);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const [search, setSearch] = useState(default_search);
  const [filter, setFilter] = useState({
    partywise: false,
    sizewise: false,
  });
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState(null);

  useEffect(() => {
    !parties?.is_fetch && get_parties();
    !sizes?.is_fetch && get_sizes();
  }, []);

  const clearState = () => {
    dispatch(
      get({
        name: "submission",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };

  const processSubmissions = (
    data,
    { partywise = false, sizewise = false }
  ) => {
    if (!data || data.length === 0) return [];

    const resultMap = new Map();
    const getKey = (item) => {
      const keys = [];
      if (partywise) keys.push(`p_${item.p_id}`);
      if (sizewise) keys.push(`s_${item.size_id}`);
      return keys.join("|") || "total";
    };

    data.forEach((item) => {
      const key = getKey(item);
      const current = resultMap.get(key) || {
        p_id: partywise ? item.p_id : null,
        size_id: sizewise ? item.size_id : null,
        stn_pcs: 0,
        stn_cts: 0,
      };

      resultMap.set(key, {
        ...current,
        stn_pcs: current.stn_pcs + (item.stn_pcs || 0),
        stn_cts: current.stn_cts + (item.stn_cts || 0),
      });
    });

    return Array.from(resultMap.values());
  };

  const handleGenerateReport = async () => {
    try {
      setLoading(true);
      let dataToProcess = submission?.data;
      if (!dataToProcess || dataToProcess.length === 0) {
        let response = await fetchData({
          api: "get_submissions",
          name: "submission",
          key: "stn_id",
          searchParams: search,
          filterCallback: null,
          showLoading,
          hideLoading,
          hold: false,
        });
        dataToProcess = response?.data;
      }
      const processedData = processSubmissions(dataToProcess, filter);
      setReports(processedData);
    } catch (error) {
      alert("Something went wrong!");
      return;
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReport = () => {
    if (!reports || reports.length === 0) {
      alert("Please generate the report first");
      return;
    }

  };

  const columns = [
    {
      id: "id",
      name: "Id",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    filter.partywise && {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      sortable: true,
    },
    filter.sizewise && {
      id: "size_id",
      name: "Size",
      selector: (row) => {
        const size = sizes?.data?.find(
          ({ size_id }) => size_id === row?.size_id
        );
        return `${size?.size_from} - ${size?.size_to}`;
      },
    },
    {
      id: "stn_pcs",
      name: "Pcs",
      selector: (row) => row?.stn_pcs,
      sortable: true,
    },
    {
      id: "stn_cts",
      name: "Weight ",
      selector: (row) => Number(row?.stn_cts).toFixed(2),
      sortable: true,
    },
  ].filter(Boolean);

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        filter={filter}
        setSearch={setSearch}
        setFilter={setFilter}
        clearState={clearState}
        parties={parties?.data}
        loading={loading}
        onGenerateReport={handleGenerateReport}
        onDownloadReport={handleDownloadReport}
        setReports={setReports}
      />

      {reports && (
        <EnhancedTable title="Reports" columns={columns} rows={reports} />
      )}
    </DashboardLayout>
  );
};

export default Report;
